import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { MaterialService } from '../../Services/Material/material.service';
import {
    GetAllMaterialStock, GetAllMaterialStockSuccess, GetAllMaterialStockError, GetAllMaterials, GetAllMaterialsByCompanyId, EMaterialActions, GetAllMaterialsSuccess, GetAllMaterialsByCompanyIdSuccess, GetAllMaterialsError, GetAllMaterialByCompanyIdError, AddMaterial,
    GetAddMaterialSuccess, GetAddMaterialError, EditMaterial, GetEditMaterialSuccess, GetEditMaterialError,
    GetMaterialCode, GetMaterialCodeSuccess, GetMaterialCodeError, InActivateMaterial, ImportMaterial, ImportMaterialSuccess, ImportMaterialError,
    InActivateMaterialSuccess, InActivateMaterialError, GetMatInventoryDetails, AddType, AddUOM,
    AddAlergens, GetSubGroupType, GetMaterialsByStatusId, GetMaterialsByStatusIdSuccess, GetMaterialsByStatusIdError,
    GetMaterialsByAgentId, GetMaterialsByAgentIdSuccess, GetMaterialsByAgentIdError, ImportExcelSheet
} from '../actions/material.action';
import { map, switchMap, catchError, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ImportExcelSheetService } from 'src/app/Services/ImportExcelSheet/import-excel-sheet.service';


@Injectable()
export class MaterialEffects {

    getallmaterialstock$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllMaterialStock>(EMaterialActions.GetAllMaterialStock),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.materialService.getAllMaterialStock(payload).pipe(
                map((result: any) => {
                    return new GetAllMaterialStockSuccess(result);
                }),
                catchError((err) => of(new GetAllMaterialStockError(err)))
            );
        })
    ));


    getallmaterials$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllMaterials>(EMaterialActions.GetAllMaterials),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.materialService.getAllMaterials(payload).pipe(
                map((result: any) => {
                    return new GetAllMaterialsSuccess(result);
                }),
                catchError((err) => of(new GetAllMaterialsError(err)))
            );
        })
    ));


    getallmaterialsbycompanyid$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllMaterialsByCompanyId>(EMaterialActions.GetAllMaterialsByCompanyId),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.materialService.GetAllMaterialsByCompanyId(payload).pipe(
                map((result: any) => {
                    return new GetAllMaterialsByCompanyIdSuccess(result);
                }),
                catchError((err) => of(new GetAllMaterialByCompanyIdError(err)))
            );
        })
    ));

    getMaterialsByStatusId$ = createEffect(() => this.actions$.pipe(
        ofType<GetMaterialsByStatusId>(EMaterialActions.GetMaterialsByStatusId),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.materialService.getMaterialsByStatusId(payload).pipe(
                map((result: any) => {
                    return new GetMaterialsByStatusIdSuccess(result);
                }),
                catchError((err) => of(new GetMaterialsByStatusIdError(err)))
            );
        })
    ));

    getMaterialByAgents$ = createEffect(() => this.actions$.pipe(
        ofType<GetMaterialsByAgentId>(EMaterialActions.GetMaterialsByAgentId),
        map(action => action.payload),
        mergeMap((payload: any) => this.materialService.getMaterialsByAgentId(payload)
            .pipe(map((result: any) => ({ type: '[Material] Get Materials By AgentId Success', payload: result, from: 'getMaterialsByAgentId' })),
                catchError((err) => of({ type: '[] Get Materials By AgentId Error', payload: err, from: 'getMaterialsByAgentId' }))
            )
        )
    ));

    importMaterial$ = createEffect(() => this.actions$.pipe(
        ofType<ImportMaterial>(EMaterialActions.ImportMaterial),
        map(action => action.payload),
        mergeMap((payload: any) => this.materialService.importMaterial(payload)
            .pipe(map((result: any) => ({ type: '[Material] Import Materials Success', payload: result, from: 'importMaterial' })),
                catchError((err) => of({ type: '[] Import Materials Error', payload: err, from: 'importMaterial' }))
            )
        )
    ));

    getaddmaterial$ = createEffect(() => this.actions$.pipe(
        ofType<AddMaterial>(EMaterialActions.AddMaterial),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.materialService.addMaterial(payload).pipe(
                map((result: any) => {
                    return new GetAddMaterialSuccess(result);
                }),
                catchError((err) => of(new GetAddMaterialError(err)))
            );
        })
    ));
    //
    // importMaterial$ = this.actions$.pipe(
    //     ofType<ImportMaterial>(EMaterialActions.ImportMaterial),
    //     map(action => action.payload),
    //     switchMap((payload: any) => {
    //         return this.materialService.importMaterial(payload).pipe(
    //             map((result: any) => {
    //                 return new ImportMaterialSuccess(result);
    //             }),
    //             catchError((err) => of(new ImportMaterialError(err)))
    //         );
    //     })
    // );


    geteditmaterial$ = createEffect(() => this.actions$.pipe(
        ofType<EditMaterial>(EMaterialActions.EditMaterial),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.materialService.editMaterial(payload).pipe(
                map((result: any) => {
                    return new GetEditMaterialSuccess(result);
                }),
                catchError((err) => of(new GetEditMaterialError(err)))
            );
        })
    ));


    getmaterialcode$ = createEffect(() => this.actions$.pipe(
        ofType<GetMaterialCode>(EMaterialActions.GetMaterialCode),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.materialService.getInternalCode(payload).pipe(
                map((result: any) => {
                    return new GetMaterialCodeSuccess(result);
                }),
                catchError((err) => of(new GetMaterialCodeError(err)))
            );
        })
    ));


    inactivatematerial$ = createEffect(() => this.actions$.pipe(
        ofType<InActivateMaterial>(EMaterialActions.InActivateMaterial),
        map(action => action.payload),
        switchMap((payload: any) => {
            return this.materialService.inactiavteMaterial(payload).pipe(
                map((result: any) => {
                    return new InActivateMaterialSuccess(result);
                }),
                catchError((err) => of(new InActivateMaterialError(err)))
            );
        })
    ));

    getMatInventory$ = createEffect(() => this.actions$.pipe(
        ofType<GetMatInventoryDetails>(EMaterialActions.GetMatInventoryDetails),
        map(action => action.payload),
        mergeMap((payload: any) => this.materialService.getMatInventory(payload)
            .pipe(map((result: any) => ({ type: '[Material] Get Mat Inventory Success', payload: result })),
                catchError((err) => of({ type: '[] Get Mat Inventory Error', payload: err, from: 'getMatInventory' }))
            )
        )

    ));

    addType$ = createEffect(() => this.actions$.pipe(
        ofType<AddType>(EMaterialActions.AddType),
        map(action => action.payload),
        mergeMap((payload: any) => this.materialService.addType(payload)
            .pipe(map((result: any) => ({ type: '[Material] Get Add Type Success', payload: result })),
                catchError((err) => of({ type: '[] Get Add Type Error', payload: err, from: 'addType' }))
            )
        )

    ));

    getSubGroupType$ = createEffect(() => this.actions$.pipe(
        ofType<GetSubGroupType>(EMaterialActions.GetSubGroupType),
        map(action => action.payload),
        mergeMap((payload: any) => this.materialService.getSubGroupType(payload)
            .pipe(map((result: any) => ({ type: '[Material] Get Sub Group Type Success', payload: result })),
                catchError((err) => of({ type: '[] Get Sub Group Type Error', payload: err, from: 'getSubGroupType' }))
            )
        )

    ));

    addUOM$ = createEffect(() => this.actions$.pipe(
        ofType<AddUOM>(EMaterialActions.AddUOM),
        map(action => action.payload),
        mergeMap((payload: any) => this.materialService.addUOM(payload)
            .pipe(map((result: any) => ({ type: '[Material] Get Add UOM Success', payload: result })),
                catchError((err) => of({ type: '[] Get Add UOM Error', payload: err, from: 'addUOM' }))
            )
        )

    ));

    addAlergens$ = createEffect(() => this.actions$.pipe(
        ofType<AddAlergens>(EMaterialActions.AddAlergens),
        map(action => action.payload),
        mergeMap((payload: any) => this.materialService.addAlergens(payload)
            .pipe(map((result: any) => ({ type: '[Material] Get Add Alergens Success', payload: result })),
                catchError((err) => of({ type: '[] Get Add Alergens Error', payload: err, from: 'addAlergens' }))
            )
        )
    ));
    // importSheet

    importExcelSheet$ = createEffect(() => this.actions$.pipe(
        ofType<ImportExcelSheet>(EMaterialActions.ImportExcelSheet),
        map(action => action.payload),
        mergeMap((payload: any) => this.importExcelSheetService.importExcelSheet(payload)
            .pipe(map((result: any) => ({ type: '[Material] Get Import Excel Sheet Success', payload: result })),
                catchError((err) => of({ type: '[] Get Import Excel Sheet Error', payload: err, from: 'ImportSheet' }))
            )
        )
    ));
    constructor(private actions$: Actions,
        private store: Store<IAppState>,
        private materialService: MaterialService,
        private importExcelSheetService: ImportExcelSheetService
    ) { }
}
